import { Component } from '@angular/core';

@Component({
    selector: 'report-window',
    template: '<router-outlet></router-outlet>',
    host: {'class': 'report-window-component'}
})
export class ReportWindowComponent {};
